import {useState, type FC, useEffect} from 'react'
import classes from './ImagesContainer.module.scss'
import LeftArrowIcon from '../../icons/images/LeftArrowIcon'
import ImageGenerated from '../../universal-components/image-generation/ImageGenerated'
import CopyIcon from '../../icons/images/CopyIcon'
import DownloadIcon from '../../icons/images/DownloadIcon'

interface ImagesContainerProps {
  images: string[]
  isLoading: boolean
  setMessage?: Function
  handleMessageVisiability?: Function
}

const ImagesContainer: FC<ImagesContainerProps> = ({
  images,
  isLoading = false,
  setMessage = () => {},
  handleMessageVisiability = () => {},
}) => {
  const [isVisibleHiddenScreen, setIsVisibleHiddenScreen] = useState<boolean>(false)
  const [currentImage, setCurrentImage] = useState<string>('/new-design/image/1.jpg')

  const handleHiddenScreen = (isVisible = true) => {
    setIsVisibleHiddenScreen(isVisible)
  }

  const handleCurrentImage = (img: string = '') => {
    setCurrentImage(img)
    handleHiddenScreen()
  }

  const handleDownloadImage = async (img: string) => {
    try {
      const response = await fetch(img, {
        headers: {mode: 'no-cors', 'Access-Control-Allow-Origin': '*'},
      })
      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'image.jpg' // You can customize the filename here
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error('Error downloading image:', error)
    }
  }
  const handleCopyImage = async (img: string) => {
    try {
      const response = await fetch(img, {
        headers: {mode: 'no-cors', 'Access-Control-Allow-Origin': '*'},
      })
      const blob = new Blob([await response.blob()], {type: 'image/png'})
      const item = new ClipboardItem({[blob.type]: blob})
      await navigator.clipboard.write([item])
      setMessage('Copied to clipboard!')
    } catch (err) {
      setMessage('Error! Copying declined!')
    } finally {
      handleMessageVisiability()
    }
  }
  const imagesBlock = images.map((item, index) => (
    <ImageGenerated
      key={index}
      image={item}
      isLoadingImg={isLoading}
      onClick={() => handleCurrentImage(item)}
    />
  ))

  useEffect(() => {
    isLoading && handleHiddenScreen(false)
  }, [isLoading])

  return (
    <div className={classes.container}>
      <div
        className={classes.container__hiddenScreen}
        style={{display: isVisibleHiddenScreen ? 'flex' : 'none'}}
      >
        <div className={classes.container__hiddenScreen__btns}>
          <button
            onClick={() => handleHiddenScreen(false)}
            title='Back to images'
            disabled={isLoading}
          >
            <LeftArrowIcon className={classes.svg} />
          </button>
          <span className={classes.container__hiddenScreen__btns__group}>
            {/* <button
              onClick={() => copyImgToClipboard(currentImage)}
              title='Copy to clipboard'
              disabled={isLoading}
            >
              <CopyIcon className={classes.svg} />
            </button>
            <button
              onClick={() => {
                downloadImg(currentImage)
              }}
              title='Download image'
              disabled={isLoading}
            >
              <DownloadIcon className={classes.svg} />
            </button> */}
            <div className={classes.container__hiddenScreen__btns__group}>
              {/* <button
              onClick={() => handleCopyImage(currentImage)}
              title='Copy to clipboard'
              disabled={isLoading}
            >
              <CopyIcon className={classes.svg} />
            </button> */}
              <a target='_blank' href={currentImage} download>
                <button title='Download image' disabled={isLoading}>
                  <DownloadIcon className={classes.svg} />
                </button>
              </a>
            </div>
          </span>
        </div>
        <img src={currentImage} alt='dalle' />
      </div>
      <div
        className={classes.container__images}
        style={{display: isVisibleHiddenScreen ? 'none' : 'grid'}}
      >
        {imagesBlock}
      </div>
    </div>
  )
}

export default ImagesContainer
